<template>
  <div class="page_container">
    <div class="EmptyLine"></div>

    <div>
      <el-form :inline="true" :model="queryParams" ref="queryForm" :size="size">
        <!--角色名称-->
        <el-form-item :label="$t('Rolemgr.RoleNameLabel')" prop="RoleName">
          <el-input v-model="queryParams.RoleName" :placeholder="$t('Rolemgr.RoleNameLabel')" clearable></el-input>
        </el-form-item>
        <!--查询按钮-->
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleGetRoleInfo">
            {{ $t("public.query") }}
          </el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">
            {{ $t("public.reset") }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div>
      <el-button :size="size" type="primary" plain icon="el-icon-plus" @click="handleOpenDialog(null, -1)">{{
        $t("public.add") }}
      </el-button>
    </div>
    <div class="EmptyLine"></div>

    <el-row :gutter="15">
      <el-col :span="12">
        <div style="
            border: 1px solid #c5d0e2;
            border-radius: 4px;
            padding: 10px;
            height: 100%;
            overflow: auto;
          ">
          <span class="page_sub_title">{{ $t("Rolemgr.RoleList") }}</span>
          <el-divider></el-divider>
          <div class="showTreediv">
            <!--行上增加鼠标指示-->
            <el-table :size="size" :data="tableData" @row-click="rowClick" highlight-current-row border
              style="width: 100%">
              <el-table-column type="index" align="center" width="60" :label="publicIndex">
              </el-table-column>
              <el-table-column prop="RoleName" align="left" :label="RolemgrRoleName">
              </el-table-column>

              <el-table-column prop="licheng" align="center" :label="publicOperation" width="200">
                <template slot-scope="scope">
                  <!-- <el-button
                    type="primary"
                    size="mini"
                    @click="handleShowRole(scope.row, 1)"
                    >{{ $t("public.Show") }}</el-button
                  > -->
                  <el-button v-if="scope.row.IsDefault != 1" size="mini" type="text" icon="el-icon-edit"
                    @click="handleOpenDialog(scope.row, 0)">{{ $t("public.edit") }}</el-button>
                  <el-button v-if="scope.row.IsDefault != 1" size="mini" type="text" icon="el-icon-delete"
                    @click="handleDelRole(scope.row)">{{ $t("public.del") }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-col>

      <el-col :span="12">
        <div style="border: 1px solid #c5d0e2; border-radius: 4px; padding: 10px">
          <span class="page_sub_title">{{ $t("Rolemgr.SelRoleMenus") }}</span>
          <el-divider></el-divider>
          <div class="showTreediv">
            <el-tree id="el-tree" class="vehicle_tree" ref="showtree" default-expand-all
              style="background-color: transparent" show-checkbox :data="menus" node-key="MenuID">
              <span slot-scope="{ node, data }">
                <span v-if="data.treeLevel != 5" class="tree_folder">{{
                  data.name
                }}</span>
                <span v-else class="tree_file"> {{ data.name }} </span>
              </span>
            </el-tree>
          </div>
        </div>
      </el-col>
    </el-row>

    <div class="LjDialog">
      <el-dialog :title="editDTName" center :visible.sync="outVisible" :close-on-click-modal="false">
        <div>
          <el-form label-width="120px" :rules="rules" :size="size">
            <el-form-item :label="$t('Rolemgr.RoleNameLabel')">
              <el-input v-model="editRoleName"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Rolemgr.RoleMenus')">
              <div style="
                  border: 1px solid #c5d0e2;
                  border-radius: 4px;
                  padding: 10px;
                  margin-top: 5px;
                ">
                <div style="height: 450px;overflow: auto;">
                  <el-tree id="el-tree2" class="vehicle_tree" ref="edittree" default-expand-all
                    style="background-color: transparent" show-checkbox :data="menus" node-key="MenuID">
                    <span slot-scope="{ node, data }">
                      <span v-if="data.treeLevel != 5" class="tree_folder">{{
                        data.name
                      }}</span>
                      <span v-else class="tree_file"> {{ data.name }}</span>
                    </span>
                  </el-tree>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>

        <div class="LjDialog-footer">
          <slot name="footer">
            <el-button style="margin: 0 10px" :size="size" type="info" @click="outClose">{{ $t("public.cancel")
            }}</el-button>
            <el-button type="primary" :size="size" @click="handleSaveRoleInfo">{{ $t("public.save") }}</el-button>
          </slot>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Rolemgr",
  data() {
    return {
      contextMenuTarget: null,
      contextMenuVisible: false,
      outVisible: false,
      editDTName: this.$t("Rolemgr.AddRole"),
      editRoleName: "",
      data: [],
      queryParams: {
        RoleName: "",
      },
      rules: {
        RoleName: [
          {
            required: true,
            message: this.$t("Rolemgr.PleaseFillRoleName"),
            trigger: "blur",
          },
        ],
      },
     
      
      selRoleID: -1,
      tableData: [],

      publicIndex: this.$t("public.index"),
      RolemgrRoleName: this.$t("Rolemgr.RoleName"),
      publicOperation: this.$t("public.Operation"),
      menus: [],
      allMenus: []
    };
  },
  computed: {
    ...mapState({
      sidebar: (state) => state.app.sidebar,
    }),
    size() {
      return this.$store.getters.size;
    },


  },
  methods: {
    getSubMenus(menus, PreMenuID) {

      var subMenus = menus.filter((e) => {
        return e.PreMenuID == PreMenuID;
      });
      subMenus.forEach((element) => {
        element.name = element.MenuName;
        element.children = this.getSubMenus(menus, element.MenuID);
      });
      return subMenus;
    },

    handleQuery() {
      this.handleGetRoleInfo();
    },
    handleOpenDialog(row, type) {
      this.outVisible = true;

      if (type == -1) {
        this.editDTName = this.$t("Rolemgr.AddRole");
        this.selRoleID = -1;
      } else {
        this.editDTName = this.$t("Rolemgr.EditRole");
        this.editRoleName = row.RoleName;
        this.selRoleID = row.RoleID;
        setTimeout(() => {
          this.handleShowRole(row, 0);
        }, 200);
      }
    },
    outClose(done) {
      this.$refs.edittree.setCheckedKeys([]);
      this.editRoleName = "";

      this.outVisible = false;
      this.selRoleID = -1;
    },
    resetQuery() {
      // console.log("resetQuery");
      this.resetForm("queryForm");
      this.handleGetRoleInfo();
    },

    handleGetRoleInfo() {
      var OperatorId = this.$store.getters.operator.OperatorId;
      var CompanyId = this.$store.getters.operator.CompanyId;

      var paraData = {
        OperatorID: OperatorId,
        SubjectCorpID: CompanyId,
      };

      this.$api
        .GetRoleOfOper(paraData)
        .then(async (res) => {
          //    console.log(res);

          if (res) {
            switch (res.code) {
              case 200:
                //过滤数据，根据 RoleName 包含 管理员 的数据
                this.tableData = res.data.filter((item) => {
                  return item.RoleName.indexOf(this.queryParams.RoleName) != -1;
                });
                this.$refs.showtree.setCheckedKeys([]);

                break;

              default:
                this.$message({
                  type: "danger",
                  message: this.$t("Rolemgr.GetRoleMenuFail"),
                });
                break;
            }
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },


    handleSaveRoleInfo() {
      var CompanyId = this.$store.getters.operator.CompanyId;
      var editRoleName = this.editRoleName.trim();
      if (editRoleName == "") {
        this.$message.warning(this.$t("Rolemgr.PleaseFillRoleName"));
        return;
      }
      var checkMenuIDs = this.$refs.edittree.getCheckedKeys();
      if (checkMenuIDs.length == 0) {
        this.$message.warning(this.$t("Rolemgr.PleaseSelRoleMenu"));
        return;
      }
      var checkPareMenuIDS = this.$refs.edittree.getHalfCheckedKeys();
      console.log(checkPareMenuIDS);
      //合并数组
      checkMenuIDs = checkMenuIDs.concat(checkPareMenuIDS);



      //没有更深以及的
      let SelMenuIDs = "";
      for (let tMenuID of checkMenuIDs) {
        //要把上一级也加进去，如果上一级不在数组中，就加进去
        SelMenuIDs += tMenuID + "@0@'''';";

      }

      //删除最后一个;
      SelMenuIDs = SelMenuIDs.substring(0, SelMenuIDs.length - 1);

      var OperatorId = this.$store.getters.operator.OperatorId;

      var paraData = {
        RoleID: this.selRoleID,
        OperatorID: OperatorId,
        RoleName: editRoleName,
        SelMenuIDs: SelMenuIDs,
        SubjectCorpID: CompanyId,
      };

      // console.log(paraData)
      // return;
      this.$api
        .SaveRoleInfo(paraData)
        .then(async (res) => {
          // console.log(res);

          if (res) {
            switch (res.code) {
              case 200:
                this.$message({
                  type: "success",
                  message: this.$t("public.hasSaved"),
                });
                this.handleGetRoleInfo();
                setTimeout(() => {
                  this.outVisible = false;
                }, 200);
                break;

              default:
                this.$message({
                  type: "danger",
                  message: this.$t("Rolemgr.角色名称重复"),
                });
                break;
            }
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    rowClick(row) {
      this.handleShowRole(row, 1);
    },
    //根据上级ID获取子菜单

    handleShowRole(row, flag) {
      var paraData = {
        RoleID: row.RoleID,
      };

      this.$api
        .GetRoleFunMenu(paraData)
        .then(async (res) => {
          console.log(res);

          if (res) {
            switch (res.code) {
              case 200:

                //只查看，不编辑
                var showCheckedD = [];
                res.data.forEach((element) => {

                  var subMenus = this.allMenus.filter((e) => {
                    return e.PreMenuID == element.MenuID;
                  });

                  if (subMenus.length == 0) {
                    showCheckedD.push(element.MenuID);
                  }
                });


                if (flag == 1) {
                  this.$refs.showtree.setCheckedKeys(showCheckedD);
                } else {
                  //编辑
                  this.$refs.edittree.setCheckedKeys(showCheckedD);
                }
                break;

              default:
                this.$message({
                  type: "danger",
                  message: this.$t("Rolemgr.GetRoleMenuFail"),
                });
                break;
            }
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    getAllMenus() {
      this.$api.getMenuByOptID({}).then(res => {
        // console.log(res);//
        if (res.code == 200) {
          this.allMenus = res.data;
          this.menus = this.getSubMenus(res.data, 0)

        }
      });
    },
    handleDelRole(row) {
      let para = {
        RoleID: row.RoleID,
      };
      this.$confirm(this.$t("Rolemgr.DelRoleConfirm"), this.$t("public.tips"), {
        confirmButtonText: this.$t("public.confirm"),
        cancelButtonText: this.$t("public.cancel"),
        type: "warning",
      })
        .then(() => {
          this.$api
            .DelRoleInfo(para)
            .then(async (res) => {
              console.log(res);

              if (res) {
                switch (res.code) {
                  case 200:
                    this.$message.success(this.$t("public.hasDeleted"));
                    this.handleGetRoleInfo();

                    break;

                  default:
                    this.$message.warning(this.$t("Rolemgr.删除失败"));

                    break;
                }
              }
            })
            .catch((res) => {
              console.log(res);
            });
        })
        .catch(() => { });
    },
  },
  mounted() {
    this.getAllMenus();
    // this.$message.success(this.$t("public.DeleteFail"));
    this.handleGetRoleInfo();
  },
};
</script>

<style scoped lang="scss">
.LjDialog {
  ::v-deep .el-dialog {
    background-color: white;
    border: 1px solid rgb(197, 208, 226);
    border-radius: 10px;
    width: 600px;
    margin-top: 8vh;

    .el-dialog__title {
      color: black;
      caret-color: transparent;
    }

    .el-icon-close {
      display: none;
      color: white;

      &:hover {
        color: rgb(9, 205, 219);
      }
    }

    .el-dialog__header {
      padding: 20px;
      padding-bottom: 10px;
      background: white;
    }

    .el-dialog__body {
      color: white;
      font-size: 12px;

      padding: 10px 10px 10px;
      line-height: 12px;
    }

    .LjDialog-footer {
      text-align: right;
      margin: 10px 0 0 0;
    }
  }
}

::v-deep .el-table__row {
  &:hover {
    background-color: #f5f7fa; // 浅灰色背景
    cursor: pointer; // 鼠标变为指针形状
  }
}

.showEditTreediv {
  height: calc(100vh - 350px) !important;
  overflow: auto;
}

.showTreediv {
  height: calc(100vh - 350px) !important;
  overflow: auto;
}

.EmptyLine {
  height: 10px;
}

.el-row {
  height: 100%;
}

.el-col-12 {
  max-height: 98%;
}

.vehicle_tree {
  .tree_folder {
    font-weight: bold;
    font-size: 12px;
    color: #0f1a3a;
    letter-spacing: 0;
    line-height: 12px;
  }

  .tree_file {
    font-size: 12px;
    color: #0f1a3a;
    letter-spacing: 0;
    line-height: 12px;

    .iconfont {
      color: #a2b1cb;
      margin-right: 8px;
    }
  }

  .online {
    .iconfont {
      color: #07b477;
    }
  }

  .header {
    display: flex;
    text-align: left;

    span {
      display: inline-block;
      flex: 1;
      font-size: 14px;
      color: #0f1a3a;
      letter-spacing: 0;
      line-height: 14px;
      font-weight: bold;
    }
  }
}

.toggle_icon {
  color: #000;
  font-size: 20px;
  cursor: pointer;
}

.is-checked span {
  color: #2a7aff !important;
}

.is-checked i {
  color: #2a7aff !important;
}
</style>
